// path/to/your/script.js
// ... existing code ...
document.addEventListener("DOMContentLoaded", function() {
    const h2Elements = document.querySelectorAll("em");
  
    h2Elements.forEach(h2 => {
      const text = h2.textContent.trim(); // Trim leading and trailing spaces
      // Split by each character, but only wrap letters in spans
      h2.innerHTML = text.split('').map(letter => {
        return letter === ' ' ? ' ' : `<span>${letter}</span>`;
      }).join('');
      
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const spans = h2.querySelectorAll('span');
            spans.forEach((span, index) => {
              span.style.animationDelay = `${index * 0.05}s`; // Stagger the animation
            });
            h2.classList.add('animate'); // Add class to trigger animation
            observer.unobserve(h2); // Stop observing after animation
          }
        });
      });
  
      observer.observe(h2); // Start observing each h2
    });

    const images = document.querySelectorAll('.image__hero__pane img'); // Select images
      // Animate images
    const imageObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate'); // Add class to trigger zoom-out
            imageObserver.unobserve(entry.target); // Stop observing after animation
        }
        });
    });

    images.forEach(image => {
        imageObserver.observe(image); // Start observing each image
    });
  });
  // ... existing code ...